import _extends from "@babel/runtime/helpers/esm/extends";
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { Box } from '..';
import { CheckboxContainer, HiddenCheckbox, LabelTypography, StyledCheckbox, StyledLabel, CheckboxWrapper, LabelToolTip } from './checkbox.style';
import Tooltip from '../Tooltip';
import Icon from '../Icon';
import ErrorMessage from '../ErrorMessage';
import Hint from '../Hint';
export const CheckboxStandard = /*#__PURE__*/forwardRef((props, ref) => {
  const {
      className = 'checkboxStandard',
      checked = false,
      hiddenLabel = false,
      error = false,
      disabled = false,
      label,
      hint,
      value,
      indeterminate = false,
      fit = 'medium',
      tooltipDescription,
      tooltipDescriptionPosition = 'right'
    } = props,
    restProps = __rest(props, ["className", "checked", "hiddenLabel", "error", "disabled", "label", "hint", "value", "indeterminate", "fit", "tooltipDescription", "tooltipDescriptionPosition"]);
  return _jsxs(Box, _extends({
    my: 2,
    className: className
  }, {
    children: [_jsxs(CheckboxWrapper, {
      children: [_jsxs(StyledLabel, _extends({
        disabled: disabled
      }, {
        children: [_jsxs(CheckboxContainer, {
          children: [_jsx(HiddenCheckbox, _extends({
            checked: checked,
            disabled: disabled,
            value: value,
            ref: ref
          }, restProps)), _jsx(StyledCheckbox, _extends({
            error: error,
            checked: checked,
            disabled: disabled,
            fit: fit
          }, {
            children: fit === 'small' ? _jsx("svg", _extends({
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
              width: "12",
              height: "12",
              viewBox: "0 0 12 12"
            }, {
              children: !indeterminate ? _jsx("path", {
                d: "M1.5 5.5L4.92615 8.92615C4.96641 8.96641 5.0321 8.96498 5.07057 8.92301L10.5 3",
                strokeWidth: "2"
              }) : _jsx("line", {
                x1: "1",
                y1: "5",
                x2: "14",
                y2: "5",
                style: {
                  stroke: 'rgb(255,255,255)',
                  strokeWidth: '3'
                }
              })
            })) : fit === 'medium' ? _jsx("svg", _extends({
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
              width: "16",
              height: "16",
              viewBox: "0 0 16 16"
            }, {
              children: !indeterminate ? _jsx("path", {
                d: "M2.5 7.5L6.92687 11.435C6.96751 11.4711 7.02958 11.4681 7.06658 11.4283L13.5 4.5",
                strokeWidth: "2"
              }) : _jsx("line", {
                x1: "2",
                y1: "8",
                x2: "15",
                y2: "8",
                style: {
                  stroke: 'rgb(255,255,255)',
                  strokeWidth: '3'
                }
              })
            })) : _jsx("svg", _extends({
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
              width: "20",
              height: "20",
              viewBox: "0 0 20 20"
            }, {
              children: !indeterminate ? _jsx("path", {
                d: "M2.5 7.5L6.92687 11.435C6.96751 11.4711 7.02958 11.4681 7.06658 11.4283L13.5 4.5",
                strokeWidth: "2"
              }) : _jsx("line", {
                x1: "2",
                y1: "10",
                x2: "19",
                y2: "10",
                style: {
                  stroke: 'rgb(255,255,255)',
                  strokeWidth: '3'
                }
              })
            }))
          }))]
        }), !hiddenLabel && !!label && _jsx(LabelTypography, _extends({
          variant: "body1",
          fontStyle: "normal",
          fit: fit
        }, {
          children: label
        }))]
      })), _jsx(LabelToolTip, {
        children: !!tooltipDescription && _jsx(Tooltip, _extends({
          fit: fit,
          content: tooltipDescription,
          width: 'auto',
          position: tooltipDescriptionPosition,
          appearance: "default"
        }, {
          children: _jsx(Icon, {
            name: "info-circle",
            size: fit === 'large' ? '24' : '20'
          })
        }))
      })]
    }), error && _jsx(ErrorMessage, _extends({
      fit: fit
    }, restProps)), hint && _jsx(Hint, _extends({
      hint: hint,
      fit: fit
    }, restProps))]
  }));
});